import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "EmpyreanOPDB" })((theme) => ({
  page: {
    margin: "20px",
  },
}));
